import * as React from 'react';
import clsx from 'clsx';

import './style.scss';

export interface IOverlayContainerProps extends React.HTMLAttributes<HTMLDivElement> {
    containerClassname?: string;
    backgroundOpacity?: number;
}

export const OverlayContainer = React.forwardRef<HTMLDivElement, IOverlayContainerProps>(
    ({
        className,
        children,
        containerClassname,
        backgroundOpacity = 9,
        ...restDivProps
    }, ref) => (
        <div
            className={clsx(className, 'overlay-wrapper', `opacity-${backgroundOpacity}`)}
            ref={ref}
            {...restDivProps}
        >
            <div className={clsx(containerClassname, 'overlay-container')}>
                { children }
            </div>
        </div>
    )
);
